<template>
  <div>
    <livechat-search v-model="showSearch"></livechat-search>
    <div id="livechat">
      <v-layout fill-height>
        <v-flex shrink fill-height style="width: 82px">
          <template v-if="$store.state.livechat.pageid">
            <livechat-pagelist
              :value="$store.state.livechat.pageid"
              @changePage="changePage"
            ></livechat-pagelist>
          </template>
        </v-flex>
        <v-flex fill-height style="position: relative; width: calc(100% - 82px)">
          <v-layout>
            <v-flex style="border-right: 1px solid #eee; max-width: 20%; min-width: 265px">
              <div id="chattype">
                <template v-if="searchlist.length == 0">
                  <livechat-tab
                    :newchatnotify="newchatnotify"
                    @onsearch="showSearch = true"
                  ></livechat-tab>
                </template>
                <template v-else>
                  <livechat-search-box @onsearch="showSearch = true"></livechat-search-box>
                  <v-divider></v-divider>
                </template>
              </div>

              <div v-if="$store.state.livechat.app">
                <users
                  :app="$store.state.livechat.app"
                  :usersearching="usersearching"
                  :filter="filter"
                  :type="'admin'"
                  v-if="$store.state.livechat.type == 'admin'"
                ></users>
                <users
                  :app="$store.state.livechat.app"
                  :usersearching="usersearching"
                  :filter="filter"
                  :type="'bot'"
                  v-if="$store.state.livechat.type == 'bot'"
                ></users>
              </div>
            </v-flex>
            <v-flex style="max-width: 80%">
              <v-layout>
                <v-flex
                  style="border-right: 1px solid #eee; position: relative; max-width: 60%"
                  fill-height
                  v-if="selectedUser"
                  :key="`chat_${selectedUser.userid}_${selectedUser.type}`"
                >
                  <chatbox
                    @endSession="onEndSession"
                    @openSession="onOpenSession"
                    :key="selectedUser.userid"
                    :newchatnotify="newchatnotify"
                  ></chatbox>
                </v-flex>
                <v-flex style="position: relative; max-width: 40%" fill-height v-if="selectedUser">
                  <livechat-chattool :selectedUser="selectedUser"></livechat-chattool>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
    <audio
      v-show="false"
      id="noti_sound"
      src="/static/sound/noti_sound.m4a"
      type="audio/x-m4a"
      preload="auto"
      controls
    ></audio>
  </div>
</template>

<style></style>

<script>
import Livechat from './Livechat.js'
export default {
  mixins: [Livechat]
}
</script>
<style>
.newnotifycount {
  line-height: 16px;
  border-radius: 15px;
  position: absolute;
  right: 3px;
  top: 5px;
  padding-left: 3px;
  padding-right: 3px;
  background-color: #ff6565;

  font-size: 10px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/Livechat.vue